/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Ai_BasicInputs */

const en_landing_pricing_compare_ai_basic = /** @type {(inputs: Landing_Pricing_Compare_Ai_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI bilingual intro`)
};

const zh_landing_pricing_compare_ai_basic = /** @type {(inputs: Landing_Pricing_Compare_Ai_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 双语简介`)
};

/**
* | output |
* | --- |
* | "AI bilingual intro" |
*
* @param {Landing_Pricing_Compare_Ai_BasicInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_ai_basic = /** @type {((inputs?: Landing_Pricing_Compare_Ai_BasicInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Ai_BasicInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_ai_basic(inputs)
	return zh_landing_pricing_compare_ai_basic(inputs)
});
export { landing_pricing_compare_ai_basic as "landing.pricing.compare_ai_basic" }